import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { MapStyle, MapType } from "./constants";

/** Interface */
interface MapStore {
	/**
	 * This is the type of the map. Hybrid, Satellite, Roadmap, Terrain.
	 */
	mapType: MapType;

	/**
	 * This function sets the type of the map.
	 * @param type
	 * @returns
	 */
	setMapType: (type: MapType) => void;

	/**
	 * This is the style of the map. Light, Dark, Auto.
	 */
	mapStyle: MapStyle;

	/**
	 * This function sets the style of the map.
	 * @param style
	 * @returns
	 */
	setMapStyle: (style: MapStyle) => void;

	/**
	 * Whether pin clustering is disabled by the user, regardless of marker count.
	 */
	disableClustering: boolean;

	/**
	 * This function toggles whether pin clustering is disabled.
	 * @returns
	 */
	toggleDisableClustering: () => void;
}

export const useMapStore = create<MapStore>()(
	persist(
		(set) => ({
			mapType: "roadmap",
			setMapType: (type) => set(() => ({ mapType: type })),
			mapStyle: "auto",
			setMapStyle: (style) => set(() => ({ mapStyle: style })),
			disableClustering: false,
			toggleDisableClustering: () =>
				set((state) => ({ disableClustering: !state.disableClustering })),
		}),
		{
			name: "msuite-map-storage",
			storage: createJSONStorage(() => localStorage),
		},
	),
);
